// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "-" + {"22":"1523851faf080bb070ca","203":"8eef29d4d1f2cc774a58","456":"7807067c3441ee988e45","666":"fb57354191ab3abedbfb","807":"719c59f577da2d4fa4a2","837":"faf8b9e6f2b9cda4a9ca","860":"1ea42bd652b33e016c95","995":"6e4883e88ad3bfb0e241"}[chunkId] + ".bundle.js";
};